import { useQuery } from "@tanstack/react-query"
import { getExternalSeller } from "@/lib/api/search.api"
import { useAuthStore } from "@/store/auth.store"

export function useExternalSeller(id: string | null | undefined, enabled: boolean) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["external-seller", id],
    queryFn: () => getExternalSeller(id!, accessToken ?? undefined),
    enabled: enabled && !!id,
    staleTime: 0,
  })
}